import Axios from 'axios'
import i18next from 'i18next'

const REQUEST_TIMEOUT = 30000

export function createBaseHttpClient() {
  return Axios.create({
    baseURL:
      (import.meta.env.VITE_BASE_APP_URL as string) || window.location.origin,
    timeout: REQUEST_TIMEOUT,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Locale': i18next.language
    },
    withCredentials: true,
    withXSRFToken: true
  })
}
